import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useState } from 'react';

import type { Protocolo } from '../types';
import { InterpretacionDialog } from './InterpretacionDialog';

interface SeccionInterpretacionProps {
  protocolo: Protocolo;
  puedeEditar: boolean;
}

export function SeccionInterpretacion({
  protocolo,
  puedeEditar,
}: SeccionInterpretacionProps): JSX.Element {
  const [dialogOpen, setDialogOpen] = useState(false);

  const tieneContenido =
    !!protocolo.interpretacion_resultados &&
    protocolo.interpretacion_resultados.trim() !== '' &&
    protocolo.interpretacion_resultados.trim() !== '<p></p>';

  return (
    <>
      <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: tieneContenido ? 2 : 0,
          }}
        >
          <Typography variant="h6">Interpretación de resultados</Typography>
          {puedeEditar && tieneContenido && (
            <Button
              startIcon={<EditIcon />}
              size="small"
              onClick={() => setDialogOpen(true)}
            >
              Editar
            </Button>
          )}
        </Box>

        {tieneContenido ? (
          <Box
            sx={{
              '& p': { my: 1 },
              '& ul, & ol': { pl: 4 },
              '& li': { my: 0.5 },
            }}
            dangerouslySetInnerHTML={{
              __html: protocolo.interpretacion_resultados!,
            }}
          />
        ) : (
          <Box>
            <Typography variant="body2" color="text.secondary" mt={puedeEditar ? 2 : 0}>
              Este protocolo no tiene interpretación cargada.
            </Typography>
            {puedeEditar && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setDialogOpen(true)}
                sx={{ mt: 2 }}
              >
                Cargar interpretación
              </Button>
            )}
          </Box>
        )}
      </Paper>

      {dialogOpen && (
        <InterpretacionDialog
          open
          onClose={() => setDialogOpen(false)}
          uidProtocolo={protocolo.uid_protocolo}
          numeroProtocolo={protocolo.numero_protocolo}
          interpretacionActual={protocolo.interpretacion_resultados}
        />
      )}
    </>
  );
}
